module.exports = __webpack_public_path__ + "img/about-smTW.cad8df75.png";